import '../filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.SurveyItemFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  selectAll: true

  initialize: (@options = {}) ->
    super
    @name = @options.name
    @alias = _.str.humanize(@options.values.name)
    @surveyId = @options.survey.id
    @surveyName = @options.survey.name

  render: ->
    if @options.values.terms.length > 0
      @$el.html @template
        self: @
        facets: @options.values.terms
      _.defer @_renderTooltip
    @

  getFacet: ->
    @options.values

  getDescription: (facet) ->
    facet.term

  addFilter: (value) ->
    @searchQuery.addSurveyItem(@name, @alias, value, @surveyName, @surveyId)
